<template>
  <div class="zm-button-group">
    <slot></slot>
  </div>
</template>
<script>
  export default {
    name: 'ZmButtonGroup'
  };
</script>
